(function() { window.GUID_4dc9a68e_1507_48a0_b435_dc0af10ceb24 = { getGuid: function() { return "4dc9a68e-1507-48a0-b435-dc0af10ceb24"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class SportEventResult extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.$control = $('#' + params[0]); //contient le Id
            }
            OnDispose() {
                this.$Control.off('click.' + this.UniqueNamespace, 'tr');
                this.$control.remove();
            }
            OnBindEvents() {
                let me = this;
                me.$Control.offon('click.' + this.UniqueNamespace, 'tr', function (e) {
                    let href = $(this).data('href');
                    if (href != null) {
                        window.location.href = href;
                    }
                });
            }
            OnControlInstantiated() {
            }
        }
        Controls.SportEventResult = SportEventResult;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=sportevent-result.js.map
